/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PlatformAnalyticsTopEntity
 */
export interface PlatformAnalyticsTopEntity {
    /**
     * 
     * @type {string}
     * @memberof PlatformAnalyticsTopEntity
     */
    entityType: string;
    /**
     * 
     * @type {string}
     * @memberof PlatformAnalyticsTopEntity
     */
    entityId: string;
    /**
     * Human-readable entity name resolved from the entity's collection
     * @type {string}
     * @memberof PlatformAnalyticsTopEntity
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof PlatformAnalyticsTopEntity
     */
    impressions: number;
    /**
     * 
     * @type {number}
     * @memberof PlatformAnalyticsTopEntity
     */
    completions: number;
    /**
     * 
     * @type {number}
     * @memberof PlatformAnalyticsTopEntity
     */
    claims: number;
    /**
     * 
     * @type {number}
     * @memberof PlatformAnalyticsTopEntity
     */
    uniqueUsers: number;
    /**
     * 
     * @type {number}
     * @memberof PlatformAnalyticsTopEntity
     */
    ctr: number;
}

/**
 * Check if a given object implements the PlatformAnalyticsTopEntity interface.
 */
export function instanceOfPlatformAnalyticsTopEntity(value: object): value is PlatformAnalyticsTopEntity {
    if (!('entityType' in value) || value['entityType'] === undefined) return false;
    if (!('entityId' in value) || value['entityId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('impressions' in value) || value['impressions'] === undefined) return false;
    if (!('completions' in value) || value['completions'] === undefined) return false;
    if (!('claims' in value) || value['claims'] === undefined) return false;
    if (!('uniqueUsers' in value) || value['uniqueUsers'] === undefined) return false;
    if (!('ctr' in value) || value['ctr'] === undefined) return false;
    return true;
}

export function PlatformAnalyticsTopEntityFromJSON(json: any): PlatformAnalyticsTopEntity {
    return PlatformAnalyticsTopEntityFromJSONTyped(json, false);
}

export function PlatformAnalyticsTopEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlatformAnalyticsTopEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'entityType': json['entityType'],
        'entityId': json['entityId'],
        'name': json['name'],
        'impressions': json['impressions'],
        'completions': json['completions'],
        'claims': json['claims'],
        'uniqueUsers': json['uniqueUsers'],
        'ctr': json['ctr'],
    };
}

export function PlatformAnalyticsTopEntityToJSON(json: any): PlatformAnalyticsTopEntity {
    return PlatformAnalyticsTopEntityToJSONTyped(json, false);
}

export function PlatformAnalyticsTopEntityToJSONTyped(value?: PlatformAnalyticsTopEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'entityType': value['entityType'],
        'entityId': value['entityId'],
        'name': value['name'],
        'impressions': value['impressions'],
        'completions': value['completions'],
        'claims': value['claims'],
        'uniqueUsers': value['uniqueUsers'],
        'ctr': value['ctr'],
    };
}

